import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const branchCashWidget: DashboardWidgetConfiguration = {
  widgetId: "branch.cash",
  name: "Cash at hand",
  description: "Current posted balances for this branch.",
  apps: [
    "configuration",
  ],
  template: "position",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.current-balances",
      ...period(1),
      select: [
        {
          type: "field",
          field: "journal_name",
          as: "journal_name",
        },
        {
          type: "field",
          field: "account_name",
          as: "account_name",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "balance",
          as: "balance",
        },
      ],
      group_by: [
        {
          field: "journal_name",
        },
        {
          field: "account_name",
        },
      ],
      order_by: [
        {
          ref: "balance",
          direction: "desc",
        },
      ],
      limit: 20,
      where: {
        type: "condition",
        field: "account_type",
        operator: "eq",
        value: "asset_cash",
      },
    },
  },
  inputs: {
    title: "Cash at hand",
    subtitle: "Current posted balances for this branch.",
    columns: [
      {
        key: "journal_name",
        label: "Journal",
      },
      {
        key: "account_name",
        label: "Cash account",
      },
      {
        key: "balance",
        label: "Balance",
        align: "end",
        format: "currency",
      },
    ],
  },
  dummyData: {
    value: "Posted",
    rows: [],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 8,
    defaultWidth: 12,
    defaultHeight: 4,
  },
};
